import { RESIZE } from './constants';
import sendMessage from './sendMessage';

let lastSize = -1;

export default (): void => {
  const app = document.getElementById('root');

  if (app) {
    const handleResize = () => {
      const newSize = app.scrollHeight;
      if (lastSize !== newSize) {
        lastSize = newSize;
        sendMessage(RESIZE, newSize + 1);
      }
    };

    window.onresize = handleResize;
    window.onload = handleResize;

    const observer = new MutationObserver(handleResize);
    observer.observe(app, { attributes: true, childList: true, subtree: true });
  }
};
